import React from 'react'
import { noDataText } from '../constants'

const CategoryCards = ({ categories }) => (
    <div className='category-cards'>
        {categories.map(({ label, description, grades, iconText, faIcon }) => (
            <div key={label} className='category-card'>
                <div className='category-icon'>
                    {iconText || <i className={faIcon} />}
                </div>
                <div className='category-name'>{label}</div>
                <div className='category-description'>{description}</div>
                <div className='category-grades'>{`שכבות: ${grades}`}</div>
            </div>
        ))}
    </div>
)

// עמוד "מה נבדק" — אבני יסוד + שטף קריאה, לפי הסוללות שהוקצו בפועל;
// קטגוריה שלא הוקצתה לא מוצגת, וסקציה ריקה מוסתרת כולה
const Slide3WhatTested = ({ data }) => {
    const { foundationCategories, fluencyCategories } = data

    if (!foundationCategories.length && !fluencyCategories.length)
        return <div className='slide-subtitle'>{noDataText}</div>

    return (
        <div className='categories-layout'>
            {foundationCategories.length > 0 &&
                <div className='category-section'>
                    <div className='category-section-title'>
                        <i className='fa-regular fa-cubes' />
                        {'אבני יסוד'}
                        <span className='category-chip'>{'תשתיות הקריאה'}</span>
                    </div>
                    <CategoryCards categories={foundationCategories} />
                </div>}

            {fluencyCategories.length > 0 &&
                <div className='category-section'>
                    <div className='category-section-title'>
                        <i className='fa-regular fa-wave-square' />
                        {'שטף קריאה'}
                        <span className='category-chip'>{'ההתמודדות בכיתה'}</span>
                    </div>
                    <CategoryCards categories={fluencyCategories} />
                </div>}
        </div>
    )
}

export default Slide3WhatTested
